// extracted by mini-css-extract-plugin
export default {"tableStyles":"HierarchyEnergyMediumTable_tableStyles__SxXNm","summaryCellStyle":"HierarchyEnergyMediumTable_summaryCellStyle__llMrl"};